// https://flickity.metafizzy.co/

import Flickity from 'flickity'

const el = document.querySelector('.js-carousel')

if (el) {
  new Flickity(el, {
    cellAlign: 'left',
    contain: true,
    draggable: false,
    autoPlay: 4000
  })
}
